import { saveOrUpdateChat } from '../Chatmodules/chatService';
import { formatIngredient } from './formatIngredient';

const buildRecipeText = (recipe) => {
    const lines = [];
    if (recipe.dificultad)    lines.push(`🔰 Dificultad: ${recipe.dificultad}`);
    if (recipe.tiempoEstimado) lines.push(`⏱ Tiempo: ${recipe.tiempoEstimado} min`);

    if (Array.isArray(recipe.ingredientes) && recipe.ingredientes.length > 0) {
        lines.push('\n**Ingredientes:**');
        recipe.ingredientes.forEach(ing => lines.push(`- ${formatIngredient(ing)}`));
    }
    if (Array.isArray(recipe.instrucciones) && recipe.instrucciones.length > 0) {
        lines.push('\n**Instrucciones:**');
        recipe.instrucciones.filter(Boolean).forEach((inst, i) =>
            lines.push(`${i + 1}. ${inst}`)
        );
    }
    return lines.join('\n');
};

export const openRecipeInChat = async (recipe, userId, navigate) => {
    if (!userId || !recipe) return;

    const chatId = `recipe-chat-${recipe.id || recipe.objectID || Date.now()}`;
    const title  = recipe.nombre || 'Receta sin nombre';
    const ts     = Date.now();

    const messages = [
        {
            id: `msg-${ts}`,
            text: `Quiero hablar sobre esta receta: **${title}**\n\n${buildRecipeText(recipe)}`,
            sender: 'user',
            timestamp: new Date().toISOString(),
        },
        {
            id: `msg-${ts + 1}`,
            text: `¡Perfecto! Ya tengo **${title}** delante 👨‍🍳\n\nPuedo ayudarte a:\n- 🔄 **Sustituir ingredientes** (alergias, lo que tengas en casa)\n- 📈 **Mejorar la técnica** (trucos de chef)\n- 📋 **Guiarte paso a paso** mientras cocinas\n- ⚖️ **Ajustar cantidades** para más o menos personas\n- 🥗 **Adaptar a dietas** específicas\n\n¿Por dónde empezamos? 🍳`,
            sender: 'assistant',
            timestamp: new Date().toISOString(),
        },
    ];

    await saveOrUpdateChat(userId, chatId, messages, title);
    navigate('/chat', { state: { openChatId: chatId } });
};